import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import { Location } from 'history'
import React from 'react'
import { Link } from 'react-router-dom'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import DividerLineDiv from 'src/components/DividerLineDiv/DividerLineDiv'
import LoadingShimmer from 'src/components/LoadingShimmer/LoadingShimmer'
import TestId from 'src/components/TestId/TestId'
import { useTranslate } from 'src/localization/Trns'
import { LocationState } from 'src/redux/createRootReducer'
import { truncateNumber } from 'src/utils/number.utils'
import { css } from 'styled-components'

export interface MetricsLinkProps {
  linkTarget?: string | Location<LocationState>
  pathname?: string
  search?: string
  activeMetricsLoaded: boolean
  metricName: string
  metricAnalytics: string
  metricTestId: string
  metric: number
  bottomPadding?: string
}

const MetricsLink: React.FC<React.PropsWithChildren<MetricsLinkProps>> = (
  props,
) => {
  const translate = useTranslate()

  const { analytics } = useAnalyticsContext()

  return (
    <>
      <DividerLineDiv
        vertical
        css={css`
          background-color: ${styleConstants.colors.gray_lightest};
          margin: 0px;
        `}
      />
      <Link
        css={css`
          padding: 40px 24px;
          ${props.bottomPadding
            ? `padding-bottom: ${props.bottomPadding};`
            : ''}
          cursor: pointer;
          &:hover {
            background-color: ${styleConstants.colors.gray_lightest};
            .link {
              ${getFontCss(
                20,
                themeConstants.colors.cta_dark,
                styleConstants.fontFamilies.regular,
              )};
            }
          }
        `}
        to={
          props.linkTarget ?? {
            pathname: props.pathname,
            search: props.search,
            state: {},
            hash: '',
          }
        }
        onClick={(): void => {
          analytics?.track(props.metricAnalytics)
        }}
        onKeyDown={(): void => {
          analytics?.track(props.metricAnalytics)
        }}
        role={'button'}
        tabIndex={0}
      >
        {!props.activeMetricsLoaded ? (
          <>
            <LoadingShimmer
              height={'19px'}
              css={css`
                margin-bottom: 8px;
              `}
            />
            <LoadingShimmer height={'19px'} />
          </>
        ) : (
          <>
            <div
              css={css`
                ${getFontCss(
                  14,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )};
                margin-bottom: 8px;
              `}
            >
              {translate(props.metricName)}
            </div>
            <TestId testId={props.metricTestId}>
              <div
                className="link"
                css={css`
                  text-decoration: underline;
                  ${getFontCss(
                    20,
                    themeConstants.colors.cta,
                    styleConstants.fontFamilies.regular,
                  )};
                `}
              >
                {truncateNumber(props.metric, 999)}
              </div>
            </TestId>
            {props.children}
          </>
        )}
      </Link>
    </>
  )
}

export default MetricsLink
